import React from 'react';

interface InfoCircleIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function InfoCircleIcon({
	width = 24,
	height = 24,
	fill = 'currentColor',
	...props
}: Readonly<InfoCircleIconProps>): JSX.Element {
	return (
		<svg
			{...props}
			fill="none"
			width={width}
			height={height}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_332_14363)">
				<path
					d="M12 2C6.47768 2 2 6.47768 2 12C2 17.5223 6.47768 22 12 22C17.5223 22 22 17.5223 22 12C22 6.47768 17.5223 2 12 2ZM12 20.3036C7.41518 20.3036 3.69643 16.5848 3.69643 12C3.69643 7.41518 7.41518 3.69643 12 3.69643C16.5848 3.69643 20.3036 7.41518 20.3036 12C20.3036 16.5848 16.5848 20.3036 12 20.3036Z"
					fill={fill}
				/>
				<path
					d="M10.9277 8.07143C10.9277 8.35559 11.0406 8.62811 11.2415 8.82904C11.4425 9.02998 11.715 9.14286 11.9992 9.14286C12.2833 9.14286 12.5558 9.02998 12.7568 8.82904C12.9577 8.62811 13.0706 8.35559 13.0706 8.07143C13.0706 7.78727 12.9577 7.51475 12.7568 7.31381C12.5558 7.11288 12.2833 7 11.9992 7C11.715 7 11.4425 7.11288 11.2415 7.31381C11.0406 7.51475 10.9277 7.78727 10.9277 8.07143ZM12.5349 10.5714H11.4634C11.3652 10.5714 11.2849 10.6518 11.2849 10.75V16.8214C11.2849 16.9196 11.3652 17 11.4634 17H12.5349C12.6331 17 12.7134 16.9196 12.7134 16.8214V10.75C12.7134 10.6518 12.6331 10.5714 12.5349 10.5714Z"
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id="clip0_332_14363">
					<rect width={24} height={24} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
